import React from 'react';
import { useTranslation } from 'react-i18next';
import { Layout } from 'fronton-react';
import {
  HeaderImageStructure,
  HeaderSection,
  OtherSection,
  RootLayout,
  StepsSection,
} from 'common/components';
import { useIsInViewport, useScrollToElement } from 'common/hooks';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  CeilingsDesignPanel,
  CeilingsGallerySection,
  CeilingsLightingTypeSection,
  CeilingsMountingTypeSection,
  CeilingsPhotoPrintingSection,
  CeilingsTypesSection,
  CeilingsQuestionSection,
} from './components';
import {
  CEILINGS_CDN_PATH,
  CEILINGS_ELEMENT_BLOCK,
  CEILINGS_LANDING_NAME,
  CEILINGS_PATH,
  getCeilingsStepsList,
} from './ceilings-constants';

/**
 * Вью страницы "Натяжные потолки"
 */
export const Ceilings: React.FC = () => {
  const { t } = useTranslation();
  const { elRef, onScrollToElement } = useScrollToElement();
  const isConsultationFormVisible = useIsInViewport(elRef, { threshold: 0 });

  return (
    <RootLayout currentPage={CEILINGS_PATH}>
      <HeaderSection
        bgColor="#3A4664"
        description={t('header.description')}
        img={
          {
            ldSrcSet: `${CEILINGS_CDN_PATH}/header/header-new-ld.jpg/header-new-ld-2.jpg`,
            dSrcSet: `${CEILINGS_CDN_PATH}/header/header-new-d.jpg/header-new-d.jpg`,
            tSrcSet: `${CEILINGS_CDN_PATH}/header/header-new-t.jpg/header-new-t.jpg`,
            mSrcSet: `${CEILINGS_CDN_PATH}/header/header-new-m.jpg/header-new-m.jpg`,
            alt: t('header.title')
          } as HeaderImageStructure
        }
        title={t('header.title')}
        mediaType="image"
      />
      <CeilingsDesignPanel
        isConsultationFormVisible={isConsultationFormVisible}
        onConsultationSignupBtnClick={onScrollToElement}
      />
      <Layout>
        <PromoBlock elementBlock={CEILINGS_ELEMENT_BLOCK} />
        <SpecialOffer onModalBtnClick={onScrollToElement} elementBlock={CEILINGS_ELEMENT_BLOCK} />
        <CeilingsTypesSection onConsultationSignupBtnClick={onScrollToElement} />
      </Layout>
      <CeilingsMountingTypeSection onConsultationSignupBtnClick={onScrollToElement} />
      <CeilingsLightingTypeSection onConsultationSignupBtnClick={onScrollToElement} />
      <Layout>
        <CeilingsPhotoPrintingSection onConsultationSignupBtnClick={onScrollToElement} />
        <CeilingsGallerySection onConsultationSignupBtnClick={onScrollToElement} />
        <StepsSection sectionTitle={t('steps-section.title')} steps={getCeilingsStepsList(t)} />
      </Layout>
      <Layout>
        <ConsultationSection
          consultationType="CEILING"
          elementBlock={CEILINGS_ELEMENT_BLOCK}
          elementText={t('consultation-section.title')}
          isCommentVisible
          sectionRef={(el: HTMLElement | null) => {
            elRef.current = el;
          }}
          sectionText={t('consultation-section.description') || ''}
          sectionTitle={t('consultation-section.title')}
        />
        <CeilingsQuestionSection />
      </Layout>
      <OtherSection
        elementBlock={`${CEILINGS_ELEMENT_BLOCK} / other`}
        landingName={CEILINGS_LANDING_NAME}
        promotionName={`${CEILINGS_ELEMENT_BLOCK}_bottom`}
      />
    </RootLayout>
  );
};
